import { render } from "./skeltonTitle_image.vue?vue&type=template&id=ef2fea9e"
import script from "./skeltonTitle_image.vue?vue&type=script&lang=js"
export * from "./skeltonTitle_image.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__